const CustomerFavSection = ({customerFavData}) => {
    const data = customerFavData[0];

  return (
    <section className="w-full h-full py-[20px]">
            <div className='w-full text-center pb-[40px] flex justify-center items-center'>
                <h1 className='font-semibold font-playfair text-4xl text-[#41220E] mx-10'>CUSTOMER <br></br>FAVOURITES</h1>
            </div>
            <div className="w-full">
                <div className="w-full flex justify-center pb-[50px] sm:pb-[20px]">
                    <div className="relative w-full xl:w-[80%] 2xl:w-[80%] flex justify-center">
                        <div className="w-[80%] h-[400px] rounded-3xl sm:hidden"
                            style={{
                                backgroundImage: `url(${data.image1})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                            }}>
                            <div className="w-full h-full bg-[#D4A373] bg-opacity-60"></div>
                        </div>
                        <div className="hidden w-[50%] 2xl:w-[40%] sm:flex justify-start lg:px-[100px]">
                            <div className="w-[340px] h-[240px] md:w-[380px] md:h-[280px] lg:w-[420px] lg:h-[320px] rounded-[100px]"
                                style={{
                                    backgroundImage: `url(${data.image1})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                }}>
                            </div>
                        </div>
                        <div className="absolute inset-0 sm:relative w-full sm:w-[50%] 2xl:w-[60%] px-[60px] lg:px-[100px] flex flex-col justify-center">
                            <h1 className="font-bold font-playfair text-3xl lg:text-3xl text-[#41220E] text-center sm:text-start mb-[40px]">{data.name1}</h1>
                            <p className="font-normal font-montserrat text-xl text-[#41220E] text-center sm:text-start">{data.content1}</p>
                        </div>
                    </div>
                </div>
                
                <div className="w-full flex justify-center pb-[50px] sm:pb-[20px]">
                    <div className="relative w-full xl:w-[80%] 2xl:w-[80%] flex justify-center">
                        <div className="w-[80%] h-[400px] rounded-3xl sm:hidden"
                            style={{
                                backgroundImage: `url(${data.image2})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                            }}>
                            <div className="w-full h-full bg-[#D4A373] bg-opacity-60"></div>
                        </div>
                        <div className="absolute inset-0 sm:relative w-full sm:w-[50%] 2xl:w-[60%] px-[60px] lg:px-[100px] flex flex-col justify-center">
                            <h1 className="font-bold font-playfair text-3xl lg:text-3xl text-[#41220E] text-center sm:text-start mb-[40px]">{data.name2}</h1>
                            <p className="font-normal font-montserrat text-xl text-[#41220E] text-center sm:text-start">{data.content2}</p>
                        </div>
                        <div className="hidden w-[50%] 2xl:w-[40%] sm:flex justify-end lg:px-[100px]">
                            <div className="w-[340px] h-[240px] md:w-[380px] md:h-[280px] lg:w-[420px] lg:h-[320px] rounded-[100px]"
                                style={{
                                    backgroundImage: `url(${data.image2})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                }}>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>
  )
}

export default CustomerFavSection
